import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FollowUs from './FollowUs';
import { connect } from 'react-redux';
import PowerUpdate from '../PowerUpdate/PowerUpdate';
import './Footer.scss';
import { bindActionCreators } from 'redux';
import * as footerActions from '../../../actionCreators/footer';
import DownloadApp from './DownloadApp';
class Footer extends PureComponent {
  static propTypes = {
    mainNavigationData: PropTypes.any,
    loginStatus: PropTypes.bool,
    section: PropTypes.any,
    footerActions: PropTypes.any.isRequired,
    enterPowerRespMsg: PropTypes.string,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      showPowerModal: false,
    };
  }

  // Need to improve this duplicate dtm calls
  handleFooterClickEvent = ({ key }) => {
    if (window.dtm.LenskartRewamp) {
 window.dtm.LenskartRewamp.footer.click.footerList(
        this.props.section,
        { key },
        this.props.loginStatus
      );
}
    if (key === 'ENTER MY POWER') {
      this.setState({ showPowerModal: true });
    }
  };
  close = () => {
    this.setState({ showPowerModal: false });
  };

  handleEyeglassesClick = ({ key }) => {
    if (window.dtm.LenskartRewamp) {
 window.dtm.LenskartRewamp.footer.click.eyeSunContact(
        this.props.section,
        this.props.loginStatus,
        'eyeglasses',
        { key }
      );
}
  };

  handleSunglassesClick = ({ key }) => {
    if (window.dtm.LenskartRewamp) {
 window.dtm.LenskartRewamp.footer.click.eyeSunContact(
        this.props.section,
        this.props.loginStatus,
        'sunglasses',
        { key }
      );
}
  };

  handleContactClick = ({ key }) => {
    if (window.dtm.LenskartRewamp) {
 window.dtm.LenskartRewamp.footer.click.eyeSunContact(
        this.props.section,
        this.props.loginStatus,
        'contact lenses',
        { key }
      );
}
  };
  hitPowerAPI = phoneVal => {
    this.props.footerActions.getPowerUpdate(phoneVal);
  };

  renderDiv = (key, item, clickHandler, { elemType, target }, catId) => {
    if (elemType === 'Link') {
      return (
        <li key={key}>
          <Link
            to={{
              pathname: typeof item[key] === 'object' ? item[key].url : item[key],
              state: { categoryId: catId || null, section: 'cat' },
            }}
            onClick={() => clickHandler({ key })}
          >
            <span>{key}</span>
          </Link>
        </li>
      );
    }
    return (
      <li key={key}>
        <a
          target={target === '_blank' ? '_blank' : '_self'}
          rel="noreferrer"
          href={typeof item[key] === 'object' ? item[key].url : item[key]}
          onClick={() => clickHandler({ key })}
        >
          <span>{key}</span>
        </a>
      </li>
    );
  };

  render() {
    const footerData = this.props.mainNavigationData && this.props.mainNavigationData.footer;
    let firstFooter = {};
    let secondFooter = {};
    let Eyeglasses = {};
    let Sunglasses = {};
    let contactLens = {};
    if (footerData) {
      firstFooter = footerData[0].menuFirst;
      secondFooter = footerData[1].menuSecond;
      Eyeglasses = footerData[2].Eyeglasses;
      Sunglasses = footerData[3].Sunglasses;
      contactLens = footerData[4]['Contact Lenses'];
    }
    const { section, loginStatus, enterPowerRespMsg, location, dataLocale } = this.props;
    const { EYEGLASSES, SUNGLASSES, CONTACT_LENSES } = dataLocale;
    return (
      <footer className="footer">
        <section>
          {<FollowUs section={section} loginStatus={loginStatus} dataLocale={dataLocale} />}
          {<DownloadApp location={location} dataLocale={dataLocale} />}
        </section>
        <section className="footer_wrap">
          <ul className="footer_top">
            {Object.keys(firstFooter).map(key => {
              return (
                (firstFooter[key].indexOf('http') === -1 &&
                  firstFooter[key].indexOf('javascript') === -1 &&
                  this.renderDiv(key, firstFooter, this.handleFooterClickEvent, {
                    elemType: 'Link',
                  })) ||
                (firstFooter[key].indexOf('javascript') === -1 &&
                  this.renderDiv(key, firstFooter, this.handleFooterClickEvent, {
                    target: '_blank',
                  })) ||
                this.renderDiv(key, firstFooter, this.handleFooterClickEvent, { target: '_self' })
              );
            })}
          </ul>
          <ul className="footer_bottom">
            {Object.keys(secondFooter).map(key => {
              return this.renderDiv(key, secondFooter, this.handleFooterClickEvent, {
                target: '_blank',
              });
            })}
          </ul>
          <div className="footer_wrap_category-nav">
            <ul className="parent-nav">
              <li>
                <span className="headline">{EYEGLASSES}</span>
                <ul className="children-nav">
                  {Object.keys(Eyeglasses).map(key => {
                    return Eyeglasses[key].url && Eyeglasses[key].url.indexOf('lenskart.com') === -1
                      ? this.renderDiv(
                          key,
                          Eyeglasses,
                          this.handleEyeglassesClick,
                          { elemType: 'Link' },
                          Eyeglasses[key].categoryId
                        )
                      : this.renderDiv(
                          key,
                          Eyeglasses,
                          this.handleEyeglassesClick,
                          { target: '' },
                          Eyeglasses[key].categoryId
                        );
                  })}
                </ul>
              </li>
              <li>
                <span className="headline">{SUNGLASSES}</span>
                <ul className="children-nav">
                  {Object.keys(Sunglasses).map(key => {
                    return Sunglasses[key].url && Sunglasses[key].url.indexOf('lenskart.com') === -1
                      ? this.renderDiv(
                          key,
                          Sunglasses,
                          this.handleSunglassesClick,
                          { elemType: 'Link' },
                          Sunglasses[key].categoryId
                        )
                      : this.renderDiv(
                          key,
                          Sunglasses,
                          this.handleSunglassesClick,
                          { target: '' },
                          Sunglasses[key].categoryId
                        );
                  })}
                </ul>
              </li>
              <li>
                <span className="headline">{CONTACT_LENSES}</span>
                <ul className="children-nav">
                  {Object.keys(contactLens).map(key => {
                    return contactLens[key].url &&
                      contactLens[key].url.indexOf('lenskart.com') === -1
                      ? this.renderDiv(
                          key,
                          contactLens,
                          this.handleContactClick,
                          { elemType: 'Link' },
                          contactLens[key].categoryId
                        )
                      : this.renderDiv(
                          key,
                          contactLens,
                          this.handleContactClick,
                          { target: '' },
                          contactLens[key].categoryId
                        );
                  })}
                </ul>
              </li>
            </ul>
          </div>
        </section>
        <div className="dittoContainer_ditto screen-hidden" />
        {this.state.showPowerModal && (
          <PowerUpdate
            hideHandler={this.close}
            showModal={this.state.showPowerModal}
            hitPowerAPI={this.hitPowerAPI}
            enterPowerRespMsg={enterPowerRespMsg}
            dataLocale={dataLocale}
          ></PowerUpdate>
        )}
      </footer>
    );
  }
}
const mapStateToProps = state => ({
  enterPowerRespMsg: state.footer.enterPowerRespMsg,
  dataLocale: state.locale
});

function mapDispatchToProps(dispatch) {
  return {
    footerActions: bindActionCreators(footerActions, dispatch),
  };
}
Footer.defaultProps = {
  mainNavigationData: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
